import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'
import 'element-ui/lib/theme-chalk/display.css'
// eslint-disable-next-line no-unused-vars
import enLang from 'element-ui/lib/locale/lang/en' // 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖
import i18n from './lang' // internationalization

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import Breadcrumb from '@/components/Breadcrumb'
import router from './router'
import GridVx from '@/components/grid/GridVx' // AgGrid
import GridEnterprise from '@/components/grid/GridEnterprise' // AgGrid
import GridPaging from '@/components/grid/GridPaging'
import GridPagingMini from '@/components/grid/GridPagingMini'
import vxFormPlugin from './plugins/vxForm'
import VxDialog from './plugins/vxDialog'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable'
import CurrencyInput from '@/components/ui/currencyInput.vue'
import MultiCalendar from '@/components/ui/MultiCalendar.vue'
import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import VxCurrencyInput from '@/components/ui/VxCurrencyInput.vue'
import GlobalDirectives from './directive/globalDirectives'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
// import echarts from 'echarts'
import { use } from 'echarts/core'
import { PieChart, BarChart, LineChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import VChart from 'vue-echarts'
use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  PieChart,
  LineChart,
  CanvasRenderer,
  BarChart
])
import './plugins/vxValidator'
import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log

import * as filters from './filters' // global filters
import Request from '@/utils/request'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import { AllModules } from '@ag-grid-enterprise/all-modules'
import { LicenseManager } from '@ag-grid-enterprise/core'

import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import VueNumberFormat from '@coders-tm/vue-number-format'
import {
  nullValueInObj,
  displayDate,
  displayCurrency,
  compareTime
} from '@/utils/helper'
import VCalendar from 'v-calendar'
import moment from 'moment'
import VueMoment from 'vue-moment'
import VueTheMask from 'vue-the-mask'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import 'vue2-timepicker/dist/VueTimepicker.css'
import VueTimepicker from 'vue2-timepicker'
import SearchComp from '@/components/ui/search.vue'
import VueMarqueeSlider from 'vue-marquee-slider'
import InfoList from '@/components/info-list/InfoList.vue'
import InfoListLabel from '@/components/info-list/InfoListLabel.vue'
import InfoListValue from '@/components/info-list/InfoListValue.vue'
import InfoListInput from '@/components/info-list/InfoListInput.vue'
import TelInput from '@/components/TelInput'

LicenseManager.setLicenseKey(
  'Yesinsoft__on_behalf_of_INSOFT_INSOFT_1Devs24_May_2020__MTU5MDI3NDgwMDAwMA==c2664c3712172898adcce8aa8d636d30'
)

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */

Vue.use(GlobalDirectives)
Vue.use(AllModules)
Vue.use(VxDialog)
Vue.use(VCalendar)
Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  // locale: enLang // 如果使用中文，无需设置，请删除\
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(VueTelInput)
Vue.use(VueMoment, { moment })
Vue.use(VueNumberFormat)
Vue.use(VueMarqueeSlider)

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.prototype.$axios = Request
Vue.prototype.$nullValueInObj = nullValueInObj
Vue.prototype.$displayDate = displayDate
Vue.prototype.$displayCurrency = displayCurrency
Vue.prototype.$compareTime = compareTime

Vue.component('GridVx', GridVx)
Vue.component('Breadcrumb', Breadcrumb)
Vue.component('GridEnterprise', GridEnterprise)
Vue.component('GridPaging', GridPaging)
Vue.component('GridPagingMini', GridPagingMini)
Vue.component('SelectWithSearchTable', SelectWithSearchTable)
Vue.component('CurrencyInput', CurrencyInput)
Vue.component('VxCurrencyInput', VxCurrencyInput)
Vue.component('TimePicker', VueTimepicker)
Vue.component('SingleCalendar', SingleCalendar)
Vue.component('MultiCalendar', MultiCalendar)
Vue.component('SearchComp', SearchComp)
Vue.component('InfoList', InfoList)
Vue.component('InfoListLabel', InfoListLabel)
Vue.component('InfoListValue', InfoListValue)
Vue.component('InfoListInput', InfoListInput)
Vue.component('CalendarSelect', CalendarSelect)
Vue.component('CalendarRange', CalendarRange)
Vue.component('vchart', VChart)
Vue.component('tel-input', TelInput)
Vue.use(CKEditor)
Vue.use(vxFormPlugin)
Vue.use(VueTelInput, {})
Vue.use(VueTheMask)
Vue.use(FloatingVue)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})

import * as dayjs from 'dayjs'

var customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)
require('dayjs/locale/vi')
dayjs.locale('vi') // use locale globally
